export class CrimeCategoryModel {
  public crimesAgainstPersons: CrimeCategoriesModel;
  public crimesAgainstProperty: CrimeCategoriesModel;
  public crimesAgainstSociety: CrimeCategoriesModel;
}

export class CrimeCategoriesModel {
  public misdemeanors: CriminalModel[];
  public felonies: CriminalModel[];
}

export class CriminalModel {
  public crimeSubCategoryId: number;
  public settingId?: number | null;
  public clientId: number;
  public crimeSubCategoryFriendlyName: string;
  public howManyAllowed: number;
  public howLong: number;
  public decision: DecisionEnum;
  public chargeType: ChargeTypeEnum;
  public overrides: OverrideModel[] = [];
}

export class OverrideModel {
  public id?: number;
  public crimeSubCategoryId: number;
  public clientId: number;
  public groupId: number;
  public howManyAllowed = 0;
  public howLong = 0;
  public decision = 'decline';
  public chargeType: ChargeTypeEnum;
}

export enum ChargeTypeEnum {
  Felony = 0,
  Misdemeanor = 1
}

export enum DecisionEnum {
  Decline = 0,
  Review = 1,
  Ignore = 2
}

export class EvictionSettingModel {
  public settingId?: number | null;
  public clientId: number;
  public howManyAllowed: number;
  public howLong: number;
  public decision: DecisionEnum;
  public chargeType: ChargeTypeEnum;
  public groupId: number;
  public isOverride: boolean = false;
  public clientLocationId : number;
}

export class BankruptcySettingModel {
  public settingId?: number | null;
  public clientId: number;
  public howManyAllowed: number;
  public howLong: number;
  public decision: DecisionEnum;
  public chargeType: ChargeTypeEnum;
  public considerDischarged: boolean;
  public isOverride: boolean;
  public groupId: number;
}


